import * as React from "react";
import Grid from "@mui/material/Grid";
import TopBar from "../../../components/TopBar/TopBar";
import { LayoutPage } from "../../../components/Layout/layoutPage";
import {
  Button,
  CircularProgress,
  IconButton,
  Pagination, Typography
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArchiveIcon from "@mui/icons-material/Archive";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState, useRef } from "react"; 
import { ModalEdit } from "../../../components/Modal/ModalEdit";
import AgentiForm from "../../../components/Formik/agentiForm";
import axios from "axios";
import useSWR from "swr";
import Box from "@mui/material/Box";
import translate from "../../../i18n/messages/translate";
import { I18n } from "../../../i18n";
import PersonIcon from "@mui/icons-material/Person";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid } from "@mui/x-data-grid";
import { CustomPagination } from "../../../components/Paginazione/pagination";
import Loading from "../../../components/Loading/loading";
import ClientiForm from "../../../components/Formik/clientiForm";
import { ModalCustom } from "../../../components/Modal/modalsCustom";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LockIcon from "@mui/icons-material/Lock";
import { useDispatch, useSelector } from "react-redux";
import { importBaseActions } from "../../../store/reducers/base";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { useDataGridStyles, usePaginationStyles } from "../../../core/MuiStyles";
import { ITEMS_PER_PAGE } from "../../../Utility";
import { LoadingInternal } from "../../../components/Loading/LoadingInternal";
import { useConfigurationsService } from "../../../services/ConfigurationsService";
//Breadcrumbs
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from "@mui/icons-material/Home";
import {useNavigationStack} from "../../providers/NavigationContext";

const Client = () => {
  const location = useLocation();
  const configurationsService = useConfigurationsService();
  const { stack, goToStack } = useNavigationStack();
  const { push } = useNavigationStack();
  const dispatch = useDispatch();
  const state = useSelector(state => state.base);
  const baseActions = importBaseActions();
  const navigate = useNavigate();
  const paginationClasses = usePaginationStyles();

  const [rows, setRows] = useState({ pageSize: ITEMS_PER_PAGE, page: 0, items: [], pageCount: 0, isRefreshing: true });
  const [filter, setFilter] = useState({ searchText: "" });
  const timerRef = useRef(null);

  const [user, setUser] = useState();
  const [openEditAgente, setOpenEditAgente] = useState(false);
  const handleCloseEditAgente = () => setOpenEditAgente(false);
  const handleOpenEditAgente = () => setOpenEditAgente(true);

  const [openEdit, setOpenEdit] = useState(false);
  const handleCloseEdit = () => {
    setOpenEdit(false);
    load(rows.page);
  };

  const handleOpenEdit = (user) => {
    setUser(user.id);
    setOpenEdit(true);
    closeUserMenu(user);
  };

  const [openDel, setOpenDel] = useState(false);
  const handleCloseDel = () => setOpenDel(false);
  const handleOpenDel = (user) => {
    setUser(user);
    setOpenDel(true);
    closeUserMenu(user);
  };

  const [openAdd, setOpenAdd] = useState(false);
  const handleCloseAdd = () => {
    setOpenAdd(false);
    load(0);
  };
  const handleOpenAdd = () => {
    setOpenAdd(true);
    closeUserMenu();
  };

  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + state.user.token,
    },
  };

  useEffect(() => {
    load(0);
  }, []);

  useEffect(() => {
    load(0);
  }, [filter]);

  const load = async (page) => {
  setRows({ ...rows, isRefreshing: true });

  try {
    let  baseUrl = `${process.env.REACT_APP_API_URL}/customers/search?&count=${rows.pageSize}&page=${page}`;
    if (location.state && location.state.agent) {
      baseUrl += `&pid=${location.state.agent.id}`;
    }
    if(filter.searchText){
      baseUrl += `&s=${encodeURI(filter.searchText)}`;
    }
    const res = await axios.get(baseUrl, axiosConfig);
    if (!res.data.success) throw res.data.message;

    const pageCount = Math.ceil(res.data.data.itemsCount / ITEMS_PER_PAGE);
    setRows({
      ...rows,
      items: res.data.data.items,
      itemsCount: res.data.data.itemsCount,
      page,
      pageCount,
      isRefreshing: false,
    });
  } catch (e) {
    console.log(e);
    setRows({ ...rows, isRefreshing: false });
  }
};



  const performSearch = (searchText) => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    timerRef.current = setTimeout(() => {
      setFilter({ searchText });
    }, 600);
  };

  const showUserMenu = (customer) => {
    document.querySelectorAll(`div.dropdown:not(div.dropdown_agent_${customer.id})`).forEach(e => {
      e.classList.remove("show");
      e.querySelector(`ul.dropdown-menu`)?.classList.remove("show");
    });

    let dropdown = document.querySelector(`div.dropdown_agent_${customer.id}`);
    let dropdownMenu = dropdown?.querySelector(`ul.dropdown-menu`);

    dropdown?.classList.toggle("show");
    dropdownMenu?.classList.toggle("show");
  };

  const closeUserMenu = () => {
    document.querySelectorAll(`div.dropdown`).forEach(e => {
      e.classList.remove("show");
      e.querySelector(`ul.dropdown-menu`)?.classList.remove("show");
    });
  };

  const resetPassword = async (customer) => {
    let res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/generate-password`, {
      id: customer.id,
    }, axiosConfig);

    res.data.success == 1 && dispatch(baseActions.setSuccess(true));
    res.data.success === 1 && alert("La password è stata reimpostata con successo. L'utente riceverà un'email con la nuova password.");

    closeUserMenu();
  };

  const getScontistica = (customer) => {
    let scontistica = "";
    if (customer.discount1 && customer.discount1 > 0) scontistica += customer.discount1;
    if (customer.discount2 && customer.discount2 > 0) scontistica += " + " + customer.discount2;
    if (customer.discount3 && customer.discount3 > 0) scontistica += " + " + customer.discount3;
    return scontistica || "0";
  };

  const createQuickConfiguration = async () => {
    try {
      setRows({ ...rows, isRefreshing: true });

      let res = await configurationsService.createQuickConfiguration(state.user.token, {});
      dispatch(baseActions.clearStorage());
      dispatch(baseActions.setQuoteId(res.id));
      dispatch(baseActions.setCustomer({ id: res.customer.id, lastName: res.customer.surname, firstName: res.customer.name, isServiceCustomer: true }));
      navigate("/products");
    } catch (e) {
      setRows({ ...rows, isRefreshing: false });
    }
  };

  if (!rows) return <Loading />;

  return (
    <I18n locale={state.locale}>
      <LayoutPage>
        <div style={{ flex: "0 0 auto" }}>
          <TopBar />
          <div className={"d-flex justify-content-between p-3"}>
            <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
              <h2 className="h2 fw-bold">{translate("Clienti")}</h2>
              <div role="presentation">
                <Breadcrumbs aria-label="breadcrumb">
                  {stack.slice().reverse().map((item, index) => {
                    const isLast = index === stack.length - 1;
                    const isFirst = index === 0;
                    return (
                      <Typography
                        key={index}
                        onClick={() => !isLast && goToStack(index)}
                        sx={{
                          cursor: isLast ? "default" : "pointer",
                          color: isFirst ? "#df5b23" : isLast ? "text.primary" : "#212529",
                          textDecoration: isLast ? "none" : "underline",
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        {isFirst ? <><HomeIcon style={{ width: "1.1rem", height: "1.2rem", marginRight: 4 }} /> Home</> : item.label}
                      </Typography>
                    );
                  })}
                </Breadcrumbs>
              </div>
            </div>
            {/*state.user.userType == "Agente" && (
              <button type="button" className="btn btn-primary me-2" onClick={createQuickConfiguration}>
                <AddIcon />
                <span className="ms-1">NUOVA CONFIGURAZIONE ANONIMA</span>
              </button>
            )*/}
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center px-3">
          <div className="d-flex align-items-center p-1" style={{ flexBasis: "30%", minWidth: "200px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="digita per iniziare la ricerca"
              onInput={(e) => performSearch(e.currentTarget.value)}
            />
          </div>
          <span className="badge rounded-pill bg-success">totale clienti: {rows.itemsCount}</span>
        </div>

        <div style={{ flex: "1 1 auto", overflowY: "auto" }}>
          <div className="px-3 pb-3">
            <table className="table table-hover table-stripped">
              <thead>
                <tr>
                  <th>Denominazione</th>
                  <th>E-mail</th>
                  <th>Località</th>
                  <th className="text-center">Scontistica</th>
                </tr>
              </thead>
              <tbody>
                {rows.items.map(customer => (
                  <tr key={customer.id} style={{ cursor: "pointer" }} onClick={() => {
                    //dispatch(baseActions.setCustomer({ id: customer.id, lastName: customer.surname, firstName: customer.name, isServiceCustomer: false }));
                    push({
                      path: "configurations",
                      label: customer.surname,
                      state: { id: customer.id,isRetail: true }
                    });
                  }}>
                    <td className="align-middle">{customer.company}</td>
                    <td className="align-middle">{customer.email}</td>
                    <td className="align-middle">{customer.city}</td>
                    <td className="align-middle text-center"><span className="badge rounded-pill bg-light text-dark">{getScontistica(customer)}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Pagination
              className={paginationClasses.root + " justify-content-end mb-0"}
              color="primary"
              count={rows.pageCount}
              page={rows.page + 1}
              onChange={(event, value) => load(value - 1)}
            />
          </div>
        </div>

        <ModalEdit title={"Nuovo cliente"} open={openAdd} handleClose={handleCloseAdd}>
          <ClientiForm handleClose={handleCloseAdd} />
        </ModalEdit>
        <ModalEdit title={"Modifica cliente"} open={openEdit} handleClose={handleCloseEdit}>
          <ClientiForm handleClose={handleCloseEdit} user={user} />
        </ModalEdit>
        <ModalCustom title={"Sicuro di eliminarlo?"} open={openDel} handleClose={handleCloseDel}>
          <Typography variant="h5">I dati eliminati non potranno essere recuperati.</Typography>
          <Grid container spacing={4} sx={{ justifyContent: "center", marginTop: 2 }}>
            <Grid item md={3} sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                startIcon={<CheckIcon sx={{ fontSize: 28 }} color={"white"} />}
                onClick={() =>
                  axios.delete(`${process.env.REACT_APP_API_URL}/customers/${user.id}?idParent=${state.agent ? state.agent.id : state.user.id}`, axiosConfig)
                    .then((res) => {
                      if (res.data.data === 1) {
                        dispatch(baseActions.setSuccess(true));
                        handleCloseDel();
                      } else {
                        alert("Ops...riprovare");
                      }
                    })
                    .catch(console.log)
                }
                variant="contained"
                sx={{ mt: 3, mb: 2, py: 1.5, fontWeight: "bold", fontSize: 16 }}
              >
                SI
              </Button>
            </Grid>
            <Grid item md={3} sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                color={"secondary"}
                onClick={handleCloseDel}
                startIcon={<CloseIcon sx={{ fontSize: 28 }} color={"white"} />}
                variant="contained"
                sx={{ mt: 3, mb: 2, py: 1.5, fontWeight: "bold", fontSize: 16, color: "white" }}
              >
                NO
              </Button>
            </Grid>
          </Grid>
        </ModalCustom>

        {rows.isRefreshing && <LoadingInternal />}
      </LayoutPage>
    </I18n>
  );
};

export default Client;
